export default {
    prompt_title: 'Are you working this edit?',
    prompt_title_plural: 'Are you working these edits?',
    // Shown under the title. Explains why the edit is sitting in their name.
    reason_client_revision: 'The client requested changes on an edit you delivered, so it came back to you.',
    reason_qc_re_edit: 'Quality Control sent your version back for changes, so it came back to you.',
    reason_bid_award: 'You won the request for this edit, so it is assigned to you.',
    reason_generic: 'This edit was assigned back to you automatically.',
    caption_with_deadline:
        'Confirm within {hours}h and it stays yours. With no answer it returns to Ready to Edit for any editor to claim.',
    caption_no_deadline: 'Confirm that you are working this edit so it stays assigned to you.',
    time_left: '{hours}h left to confirm',
    time_left_soon: 'Less than an hour left to confirm',
    mark_as_working: 'Mark as working',
    marking: 'Confirming…',
    decide_later: 'Decide later',
    open_edit: 'Open the edit',
    counter: '{current} of {total}',
    // Proofing-room banner.
    banner_title: 'This edit is waiting on your confirmation',
    banner_caption_with_deadline:
        'It came back to you automatically. Confirm within {hours}h or it returns to Ready to Edit for any editor to claim.',
    banner_caption_no_deadline: 'It came back to you automatically. Confirm that you are working it.',
    // Claim confirmation checkbox.
    claim_acceptance: "I'm accepting this video and I'm ready to start working now",
    claim_acceptance_required: 'Please confirm you are ready to start working before claiming.',
}
